const actions = {
    clearCheckout({commit}) {
        commit('errors/setMessage', '', {root: true});
        commit('orders/setOrder', '', {root: true});
        commit('payments/setStripe', '', {root: true});
        commit('errors/setErrors', [], {root: true});
        commit('cart/SET_CART', [], {root: true});
    }
}
export default {
    namespaced: true,
    actions
}
